import { DrawOptions, MapUIConfig, SupportedDrawnLayers, SupportedFeature } from '@msaf/maps-common'
import { Feature, Geometry, Id, Polygon, Properties } from '@turf/helpers'
import { FeatureState } from './utils/state-management'
import { FeatureFilterGroup } from './feature-filter-groups/types'

export interface FeatureMapFeatureOptions {
  edit?: boolean
  create?: boolean
  delete?: boolean
  view?: boolean
}

export enum ServerOperationTypes {
  'CREATE' = 'create',
  'UPDATE' = 'update',
}

export interface ServerOperationType {
  serverOperation?: ServerOperationTypes
}

export type SuperFeature = {
  config: SupportedFeature
  feature: Feature<Geometry> & ServerOperationType
  layer: SupportedDrawnLayers
}

export type FeatureMapContextProps = {
  uiConfig: MapUIConfig
  selectedFeature: SuperFeature | null
  collectionState: FeatureState
  drawOptions: Partial<DrawOptions>
  clearFeatureSelection: () => void
  removeFeature: (featureId?: string | number) => void
  drawFeature: (featureType: string) => Promise<SupportedDrawnLayers | null>
  setDrawOptions: (options: Partial<DrawOptions>) => void
  setSnappable: (canSnap: boolean) => void
  cancelDrawing: () => void
  upsertFeature: (feature: Feature<Geometry>) => void
  actionUrlTemplate?: string
  featureToggle: FeatureMapFeatureOptions
  editFeature: (id: Id) => void
  createFeature: (layer: SupportedDrawnLayers) => void
  duplicateFeature: (feature: Feature<Polygon>, featureType: string, properties?: Properties) => void
  selectFeature: (id: Id) => void
  isLoading: boolean

  filterGroups: FeatureFilterGroup[]
  upsertFilterGroup: (filterGroup: FeatureFilterGroup) => void
  removeFilterGroup: (filterGroup: FeatureFilterGroup) => void
  toggleAll: boolean | null
  setToggleAll?: (state: boolean | null) => void
}

export type CenterMode = 'static' | 'toFeatures'
